import type { FC, ReactNode } from 'react'
import type { BigLinkProps } from '@/types'

import Link from 'next/link'

import { useMagnetic } from '@/hooks/use-magnetic'
import { EASE_CLASS, MICRO_FAINT } from '@/constants/type'

/** A large serif link that leans toward the cursor, with a rule that extends. */
export const BigLink: FC<BigLinkProps> = ({ href, label, eyebrow }): ReactNode => {
    const { ref, onPointerMove, onPointerLeave } = useMagnetic<HTMLSpanElement>(0.16)

    return (
        <Link
            href={href}
            className='group block'
            onPointerMove={onPointerMove}
            onPointerLeave={onPointerLeave}
        >
            {eyebrow ? <span className={`block ${MICRO_FAINT}`}>{eyebrow}</span> : null}

            <span className='mt-6 flex flex-wrap items-center gap-x-8 gap-y-4'>
                <span
                    ref={ref}
                    className={`inline-block font-serif leading-none tracking-[-0.025em] text-fz-ink transition-transform duration-300 ${EASE_CLASS}`}
                    style={{ fontSize: 'clamp(2rem, 6vw, 4.5rem)' }}
                >
                    {label}
                </span>

                <span
                    aria-hidden='true'
                    className={`hidden h-px w-16 bg-fz-rule-on transition-all duration-700 group-hover:w-28 sm:block ${EASE_CLASS}`}
                />
            </span>
        </Link>
    )
}
